<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose" top="5vh">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="compact-form">
      <el-form-item label="订单明细编号">
        <el-input v-model="form.orderItemId" style="width: 100%;" readonly="true"></el-input>
      </el-form-item>

      <el-form-item label="商品图片">
        <img :src="form.itemImage || '/static/img/default-product.png'"
             style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; border: 1px solid #e4e7ed;"
             @error="handleImageError" />
      </el-form-item>

      <el-form-item label="商品名称">
        <span>{{ form.itemName || '-' }}</span>
      </el-form-item>

      <el-form-item label="商品规格">
        <span>{{ form.itemModelName || '-' }}</span>
      </el-form-item>

      <el-form-item label="数量">
        <span>{{ form.amount || '-' }}</span>
      </el-form-item>

      <el-form-item label="采购途径">
        <dict-tag :value="form.purchaseChannel" category-id="PURCHASE_CHANNEL"></dict-tag>
      </el-form-item>

      <el-form-item label="采购金额">
        <span>{{ form.purchaseAmount ? form.purchaseAmount.toFixed(2) : '-' }} 元</span>
      </el-form-item>

      <el-form-item label="处理类型" prop="applyType">
        <el-radio-group v-model="form.applyType" @change="handleApplyTypeChange" :disabled="isAppliedRefund">
          <el-radio label="refund">申请退款</el-radio>
          <el-radio label="putIn">不退采买做入库</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="申请退款金额" prop="applyAmount" v-if="form.applyType === 'refund'">
        <el-input-number
          v-model="form.applyAmount"
          :precision="2"
          :min="0.01"
          :max="99999.99"
          placeholder="请输入申请退款金额"
          style="width: 200px;">
        </el-input-number> 元
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '确 定' }}
      </el-button>
      <el-button @click="handleDialogClose">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { applyRefund, applyPutIn } from '../../api/OrdRefund'
import DictTag from '../../components/DictTag'

export default {
  components: {
    DictTag
  },
  name: 'OrdRefundEdit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        orderItemId: '',
        itemName: '',
        itemModelName: '',
        itemImage: '',
        amount: null,
        purchaseChannel: '',
        purchaseAmount: null,
        applyType: 'refund',
        applyAmount: null
      },
      baseRules: {
        applyType: [
          { required: true, message: '请选择申请类型', trigger: 'change' }
        ],
        applyAmount: [
          { required: true, message: '请输入申请退款金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '申请退款金额必须大于0', trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return '处理'
    },
    rules() {
      const rules = { ...this.baseRules }

      // 如果选择的是不退采买做入库，则不需要验证金额
      if (this.form.applyType === 'putIn') {
        delete rules.applyAmount
      }

      return rules
    },
    // 判断是否为已申请退款状态
    isAppliedRefund() {
      return this.editData.applyStatus === '1'
    },

  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm()
      }
    }
  },
  methods: {
    initForm() {
      // 如果是已申请退款状态，则显示原有数据并禁用处理类型选择
      if (this.editData.applyStatus === '1') {
        this.form = {
          orderItemId: this.editData.orderItemId || '',
          itemName: this.editData.itemName || '',
          itemModelName: this.editData.itemModelName || '',
          itemImage: this.editData.itemImage || '',
          amount: this.editData.amount || null,
          purchaseChannel: this.editData.purchaseChannel || '',
          purchaseAmount: this.editData.purchaseAmount || null,
          applyType: 'refund', // 强制设置为申请退款
          applyAmount: this.editData.applyAmount || null // 显示原来的申请退款金额
        }
      } else {
        this.form = {
          orderItemId: this.editData.orderItemId || '',
          itemName: this.editData.itemName || '',
          itemModelName: this.editData.itemModelName || '',
          itemImage: this.editData.itemImage || '',
          amount: this.editData.amount || null,
          purchaseChannel: this.editData.purchaseChannel || '',
          purchaseAmount: this.editData.purchaseAmount || null,
          applyType: 'refund',
          applyAmount: this.editData.purchaseAmount || null // 默认等于采购金额
        }
      }

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    handleApplyTypeChange(value) {
      // 当切换申请类型时，清空金额
      if (value === 'putIn') {
        this.form.applyAmount = null
      }
      
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 确认提交
          const message = this.form.applyType === 'refund' 
            ? `确认申请退款 ${this.form.applyAmount} 元？`
            : '确认不退采买做入库？'
          
          this.$confirm(message, '确认操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitForm()
          })
        }
      })
    },

    submitForm() {
      this.submitting = true
      
      if (this.form.applyType === 'refund') {
        // 申请退款
        const params = {
          orderItemId: this.form.orderItemId,
          applyAmount: this.form.applyAmount
        }

        applyRefund(params).then(() => {
          this.$message.success('申请退款成功')
          this.$emit('success')
        }).catch(() => {
          this.submitting = false
        })
      } else {
        // 不退采买做入库
        const params = {
          orderItemId: this.form.orderItemId
        }

        applyPutIn(params).then(() => {
          this.$message.success('申请入库成功')
          this.$emit('success')
        }).catch(() => {
          this.submitting = false
        })
      }
    },

    handleDialogClose() {
      this.submitting = false
      this.$emit('close')
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.src = '/static/img/default-product.png'
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.item-info-display {
  display: flex;
  align-items: center;
}

.compact-form .el-form-item {
  margin-bottom: 15px;
}

.compact-form .el-form-item__label {
  line-height: 28px;
}

.compact-form .el-form-item__content {
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/OrdRefundEdit.vue